import React, { useState, useEffect } from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";


const FAQ: React.FC = () => {
  const [faqActiveIndex, setFaqActiveIndex] = useState<number | null>(null);

  const toggleFaq = (index: number) => {
    setFaqActiveIndex(faqActiveIndex === index ? null : index);
  };

  useEffect(() => {
    document.title = "Frequently Asked Questions | AccuPrice";
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-content">
      <Navbar />
      <div className="faq-container">
        <h2 className="section-heading">Frequently Asked Questions</h2>
        <p className="section-subtitle">Here are some frequently asked questions about AccuPrice</p>
        {[
          { question: "How do I sign up and access the price lists?", answer: "Simply create an account on our website to access the user portal. Once logged in, you can choose the specific price list you need (electrical, plumbing, lumber, etc.) and either purchase a limited free edition or subscribe for monthly updates." },
          { question: "Can I customize the price lists to include my own profit markups and sales tax rates?", answer: "Yes, our price lists are fully customizable. You can configure profit markups for various price ranges and set your sales tax rates to ensure the lists match your specific business needs." },
          { question: "How often are the price lists updated?", answer: "The price lists are updated monthly, ensuring you always have access to the latest pricing data from large Big Box Stores in the United States." },
          { question: "What formats are the price lists available in?", answer: "The price lists are available as downloadable Excel files, which can be easily integrated into software programs like QuickBooks." },
          { question: "How do I integrate the price lists into QuickBooks or other software?", answer: "After downloading the price list, you can import the Excel file into QuickBooks or other compatible software. We provide step-by-step guides and how-to videos to assist with this process." },
          { question: "What if the products or materials I need are not listed?", answer: "Our price lists cover a wide range of general items designed by electricians, plumbers, and contractors. If specific items are not listed, please contact our support team, and we will do our best to accommodate your needs in future updates." },
          { question: "How secure is my data on your platform?", answer: "We prioritize data security and employ industry-standard measures to protect your information. Your data is securely stored and never shared with third parties." },
          { question: "Are there any additional costs besides the subscription or purchase price?", answer: "No, there are no hidden fees. The subscription or purchase price covers all costs, including updates and customer support. These FAQs address common concerns and provide clear, helpful information to potential users, enhancing their understanding and confidence in your product." },
          { question: "How do I know which price list is right for my business?", answer: "Each price list is tailored for specific industries, such as electrical, plumbing, and lumber. Review the descriptions of each list to determine which one aligns with your business needs. Our support team is also available to help you choose the best option." },
          { question: "How often do I need to update the price lists in my software?", answer: "We recommend updating your price lists every quarter when new editions are released to ensure you have the most current pricing information." },
          { question: "What if I need to cancel my subscription?", answer: "You can cancel your subscription at any time through your user portal. If you cancel, you will still have access to the price lists for the remainder of the subscription period. We do not offer refunds once you have made an annual subscription. Please see the Terms and Conditions for more details." },
          { question: "How long does it take to set up and start using the price lists?", answer: "The setup process is quick and straightforward. Once you sign up, you can access and download your price lists immediately. Customization and integration into your software should only take a few minutes with our guides and support." },
        ].map((faq, index) => (
          <div className="faq-item" key={index}>
            <button className={`faq-question ${faqActiveIndex === index ? "active" : ""}`} onClick={() => toggleFaq(index)}>
              {faq.question}
            </button>
            <div className="faq-answer" style={{ maxHeight: faqActiveIndex === index ? "none" : 0 }}>
              <p>{faq.answer}</p>
            </div>
          </div>
        ))}
      </div>

      {/* CTA Section */}
      <section className="learn-section">
        <h2 className="section-heading">Ready to Get Started?</h2>
        <p className="section-subtitle">Join AccuPrice today and access accurate, up-to-date price lists for your industry.</p>
        <div className="learn-buttons">
          <a href="/register" className="learn-btn" style={{
            display: "inline-block",
            backgroundColor: "orange",
            color: "white",
            padding: "0.75rem 1.5rem",
            fontSize: "1rem",
            fontWeight: "bold",
            borderRadius: "10px",
            textDecoration: "none",
            textAlign: "center",
            cursor: "pointer",
            margin: "0.5rem",
          }}>Sign Up Now</a>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default FAQ; 